module.exports = __webpack_public_path__ + "img/uk_success_1.582a36b8.png";